import Vue from 'vue'
import store from '@/store/Store';
import Util from '@/common/Util';
import * as DateTime from '@/common/DateTime';

export default class Task {
  constructor(name = 'none', dateDue = DateTime.getNow(), hoursPlanned = -1) {
    this.name = name;
    this.uuid = Util.uuidv4();
    this.dateAdded = DateTime.getNow();
    this.dateDue = dateDue;
    this.hoursPlanned = hoursPlanned;
    // this.hoursSpent = 0;
    this.pctDone = 0;
    // this.num = 0;
    this.num = store.getters.getNewTaskNumber;
    this.parentus = [];
    this.childus = [];
    // this.work = [];
    this.drawnWidth = 0;
    this.drawnHeight = 0;
    this.drawnX = 0;
    this.drawnY = 0;
    this.ytop = 0;
    this.ybot = 0;
    this.xleft = 0;
    this.xrght = 0;
  }
  toString() {
    // console.log('this', this);
    // return this.num + ':' + this.name + '(' + this.dateDue + '|' + this.hoursSpent+':'+ this.hoursPlanned+ '=' + this.pctDone +'%)';
    // return this.num + '|' + this.pctDone + '%|' + this.dateDue.dateToString() + ' : ' + this.name;
    return this.num + '|' + this.pctDone + '%|' + DateTime.dateTimeToString(this.dateDue) + ' : ' + this.name;
    // return this.num + '|' + this.pctDone + '%|' + ' : ' + this.name;
  }
  printTask() {
    let str = this.num + ':' + this.name + '(' + this.dateDue + '|' + this.hoursPlanned + '=' + this.pctDone + '%)';
    if (0 < this.parentus.length) {
      str += '\nparents[';
      for (let u of this.parentus) {
        str += u;
        if (this.parentus.indexOf(u) < this.parentus.length - 1) {
          str += ', ';
        }
      }
      str += ']';
    }
    if (0 < this.childus.length) {
      str += '\nchildus[';
      for (let u of this.childus) {
        str += u;
        if (this.childus.indexOf(u) < this.childus.length - 1) {
          str += ', ';
        }
      }
      str += ']';
    }
    console.log(str);
  }
  calculateSize() {
    let buffer = 5; //buffer from the rectangle border
    this.drawnWidth = 20;
    // this.drawnWidth = DC.ctx.measureText( this.toString() ).width + buffer;
    let heightFont = 11;
    this.drawnHeight = heightFont + buffer;
  }

  // getTaskStyle(){
  //   //due date is approaching
  //   let today = new DateTime.DateTime();
  //   today.setNow();
  //   let borderStyle = '';
  //   let fillStyle = '';
  //   let textStyle = '';
  //
  //   let red = 'rgb(255,0,0)';
  //   let org = 'rgb(255,127,0)';
  //   let ylw = 'rgb(255,220,0)';
  //   let grn = 'rgb(000,150,000)';
  //   let cyn = 'rgb(120,255,140)';
  //   let gry = 'rgb(100,100,100)';
  //   let wht = 'rgb(255,255,255)';
  //   let blk = 'rgb(0,0,0)';
  //
  //   // console.log(this.name + ' = ' + this.dateDue.diffHours(today) );
  //   if (this.dateDue.diffHours(today) < 0){ //red background and border
  //     textStyle = blk;
  //     borderStyle = red;
  //     fillStyle = red;
  //   } else if (this.dateDue.diffHours(today) < 72){ //red border
  //     textStyle = blk;
  //     borderStyle = red;
  //     fillStyle = wht;
  //   } else if (this.dateDue.diffHours(today) < 120){ //orange border
  //     textStyle = blk;
  //     borderStyle = org;
  //     fillStyle = wht;
  //   } else if (this.dateDue.diffHours(today) < 240){ //yellow border
  //     textStyle = blk;
  //     borderStyle = ylw;
  //     fillStyle = wht;
  //   } else if (this.dateDue.diffHours(today) < 336){ //green border
  //     textStyle = blk;
  //     borderStyle = grn;
  //     fillStyle = wht;
  //   } else{ // no border
  //     textStyle = blk;
  //     borderStyle = wht;
  //     fillStyle = wht;
  //   }
  //   console.log(this.num + ' ' + this.pctDone + ' ' + this.name );
  //
  //   //if done override preceeding
  //   if (100 <= this.pctDone){
  //     textStyle = gry;
  //     borderStyle = gry;
  //     fillStyle = wht;
  //   }
  //   return { stroke: borderStyle, text: textStyle, fill: fillStyle };
  // }
} //Task


